module.exports = __webpack_public_path__ + "img/secondary_6x4_z16.bcc3b511.svg";